module.exports = __webpack_public_path__ + "media/images/icons/mobile-3b3bb32de139458d5fc638835810fbaf.png";